import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  Back,
  Check,
  Close,
  DArrowLeft,
  DArrowRight,
  Plus,
  StarFilled,
} from '@element-plus/icons-vue';
import {
  ElButton,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElCheckbox,
  ElCollapse,
  ElCollapseItem,
  ElDatePicker,
  ElDialog,
  ElIcon,
  ElInput,
  ElOption,
  ElPopover,
  ElRadio,
  ElRate,
  ElSegmented,
  ElSelect,
  ElSkeleton,
  ElSkeletonItem,
  ElSlider,
  ElSwitch,
  ElTabPane,
  ElTabs,
  ElTimePicker,
  ElTimeSelect,
  ElTooltip,
  provideGlobalConfig,
} from 'element-plus';
import fr from 'element-plus/dist/locale/fr.mjs';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'element-plus/dist/index.css';

// Libellés d'Element UI, lus par les formats `dddd` et `MMM` des pickers (« Sam. 24 Oct. 2026 »).
Object.assign(dayjs.Ls.fr, {
  weekdays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  monthsShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
});

const components = [
  ElButton,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElCheckbox,
  ElCollapse,
  ElCollapseItem,
  ElDatePicker,
  ElDialog,
  ElIcon,
  ElInput,
  ElOption,
  ElPopover,
  ElRadio,
  ElRate,
  ElSegmented,
  ElSelect,
  ElSkeleton,
  ElSkeletonItem,
  ElSlider,
  ElSwitch,
  ElTabPane,
  ElTabs,
  ElTimePicker,
  ElTimeSelect,
  ElTooltip,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  Back,
  Check,
  Close,
  DArrowLeft,
  DArrowRight,
  Plus,
  StarFilled,
];

// `prefix-icon="icon-none"` masque l'icône des pickers.
const IconNone = { name: 'IconNone', render: () => null };

export default {
  install(app) {
    [...components, IconNone].forEach((component) => app.component(component.name, component));
    provideGlobalConfig({ locale: fr, valueOnClear: '' }, app, true);
  },
};
